var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _path4, _line, _line2, _polyline, _line3, _line4, _polyline2, _rect9, _rect0, _rect1, _rect10, _rect11, _circle, _circle2, _path5, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _polygon9, _rect24, _rect25, _circle3, _polygon0, _path6, _g, _path7, _path8, _path9, _path0, _path1, _polygon1, _path10, _path11, _g2, _path12, _rect26, _g3, _path13, _path14, _path15, _polyline3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eb56cac1-988a-4970-8192-095cb31178d1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 880.92,
    height: 737.5,
    viewBox: "0 0 880.92 737.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b5b2e68b-c285-4ac0-b26c-c5e680cf112d",
    x1: 194,
    y1: 524,
    x2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3e855d09-ea58-4275-8d16-3996ecf7bf97",
    x1: 256.5,
    y1: 341,
    x2: 256.5,
    y2: 261,
    xlinkHref: "#b5b2e68b-c285-4ac0-b26c-c5e680cf112d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf2af733-ecbd-4844-bce5-a175ed323afb",
    x1: 698.41,
    y1: 686.91,
    x2: 698.41,
    y2: 411,
    xlinkHref: "#b5b2e68b-c285-4ac0-b26c-c5e680cf112d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "41d3ff72-5c81-40b1-a081-9da170d960ca",
    x1: 521,
    y1: 592.5,
    x2: 564,
    y2: 592.5,
    xlinkHref: "#b5b2e68b-c285-4ac0-b26c-c5e680cf112d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "861d31c1-c685-4668-90c5-63e7f330b62f",
    x1: 864,
    y1: 667,
    x2: 864,
    y2: 506,
    xlinkHref: "#b5b2e68b-c285-4ac0-b26c-c5e680cf112d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "95aca10b-5f5c-4c4a-b42d-5e0345d77cda",
    x1: 587,
    y1: 666,
    x2: 587,
    y2: 505,
    xlinkHref: "#b5b2e68b-c285-4ac0-b26c-c5e680cf112d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "447533d7-1588-4f38-833a-a610814ab16b",
    x1: 818.5,
    y1: 672,
    x2: 818.5,
    y2: 507,
    xlinkHref: "#b5b2e68b-c285-4ac0-b26c-c5e680cf112d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff2ef3d2-e251-4fff-9ce5-91d443983582",
    x1: 692.5,
    y1: 520,
    x2: 692.5,
    y2: 503,
    xlinkHref: "#b5b2e68b-c285-4ac0-b26c-c5e680cf112d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3aee67b7-7918-445b-a8b6-3ab74317d2c0",
    x1: 696.5,
    y1: 492,
    x2: 696.5,
    y2: 407,
    xlinkHref: "#b5b2e68b-c285-4ac0-b26c-c5e680cf112d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6f730dc9-6dcb-4b79-bb23-db206ebc09d2",
    x1: 696.5,
    y1: 503,
    x2: 696.5,
    y2: 482,
    xlinkHref: "#b5b2e68b-c285-4ac0-b26c-c5e680cf112d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fad0dffe-d445-4baa-a242-e8cd9004e0b5",
    x1: 695,
    y1: 448,
    x2: 695,
    y2: 438,
    xlinkHref: "#b5b2e68b-c285-4ac0-b26c-c5e680cf112d"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "processing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 524,
    fill: "url(#b5b2e68b-c285-4ac0-b26c-c5e680cf112d)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 8,
    width: 358,
    height: 506,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 17,
    height: 506,
    fill: "#f5f5f5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 383,
    width: 240,
    height: 6,
    fill: "#e0e0e0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 406,
    width: 240,
    height: 6,
    fill: "#69f0ae",
    opacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 429,
    width: 240,
    height: 6,
    fill: "#ff0",
    opacity: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 452,
    width: 240,
    height: 6,
    fill: "#e0e0e0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 475,
    width: 240,
    height: 6,
    fill: "#e0e0e0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321.09,171.55c.1-1.11.16-2.23.16-3.36a37.33,37.33,0,0,0-1.45-10.3l-4.35.21-2-5.48,2.81-3.07a37.72,37.72,0,0,0-8.9-10.44l-3.43,2.66-4.78-3.34.55-4.13a37.17,37.17,0,0,0-13.27-3.45L285.14,135h-5.83l-1.92-3.7a37.33,37.33,0,0,0-18.13,8.63l2,3.84-4.12,4.12-4-1.25a37.29,37.29,0,0,0-5.73,12.46l3.88,2-1,5.74-4,1.25s0,.06,0,.09a37.25,37.25,0,0,0,2.49,13.4l4.32-.59,2.46,5.28-2.53,3.3a37.76,37.76,0,0,0,9.76,9.64l3.19-3,5.05,2.92-.18,4.18a37.28,37.28,0,0,0,12.9,2.29l.63,0,.92-4.25,5.81-.51,2.24,3.52a37.32,37.32,0,0,0,12.38-5.9l-1.68-4,4.47-3.75,3.84,1.59a37.45,37.45,0,0,0,6.79-11.92l-3.68-2.32,1.51-5.63Zm-37.3,24.68a28,28,0,1,1,28-28A28.07,28.07,0,0,1,283.79,196.23Z",
    transform: "translate(-159.54 -82)",
    fill: "#6c63ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M367.09,240.55c.1-1.11.16-2.23.16-3.36a37.33,37.33,0,0,0-1.45-10.3l-4.35.21-2-5.48,2.81-3.07a37.72,37.72,0,0,0-8.9-10.44l-3.43,2.66-4.78-3.34.55-4.13a37.17,37.17,0,0,0-13.27-3.45L331.14,204h-5.83l-1.92-3.7a37.33,37.33,0,0,0-18.13,8.63l2,3.84-4.12,4.12-4-1.25a37.29,37.29,0,0,0-5.73,12.46l3.88,2-1,5.74-4,1.25s0,.06,0,.09a37.25,37.25,0,0,0,2.49,13.4l4.32-.59,2.46,5.28-2.53,3.3a37.76,37.76,0,0,0,9.76,9.64l3.19-3,5.05,2.92-.18,4.18a37.28,37.28,0,0,0,12.9,2.29l.63,0,.92-4.25,5.81-.51,2.24,3.52a37.32,37.32,0,0,0,12.38-5.9l-1.68-4,4.47-3.75,3.84,1.59a37.45,37.45,0,0,0,6.79-11.92l-3.68-2.32,1.51-5.63Zm-37.3,24.68a28,28,0,1,1,28-28A28.07,28.07,0,0,1,329.79,265.23Z",
    transform: "translate(-159.54 -82)",
    fill: "#6c63ff",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M414.09,171.55c.1-1.11.16-2.23.16-3.36a37.33,37.33,0,0,0-1.45-10.3l-4.35.21-2-5.48,2.81-3.07a37.72,37.72,0,0,0-8.9-10.44l-3.43,2.66-4.78-3.34.55-4.13a37.17,37.17,0,0,0-13.27-3.45L378.14,135h-5.83l-1.92-3.7a37.33,37.33,0,0,0-18.13,8.63l2,3.84-4.12,4.12-4-1.25a37.29,37.29,0,0,0-5.73,12.46l3.88,2-1,5.74-4,1.25s0,.06,0,.09a37.25,37.25,0,0,0,2.49,13.4l4.32-.59,2.46,5.28-2.53,3.3a37.76,37.76,0,0,0,9.76,9.64l3.19-3,5.05,2.92-.18,4.18a37.28,37.28,0,0,0,12.9,2.29l.63,0,.92-4.25,5.81-.51,2.24,3.52a37.32,37.32,0,0,0,12.38-5.9l-1.68-4,4.47-3.75,3.84,1.59a37.45,37.45,0,0,0,6.79-11.92l-3.68-2.32,1.51-5.63Zm-37.3,24.68a28,28,0,1,1,28-28A28.07,28.07,0,0,1,376.79,196.23Z",
    transform: "translate(-159.54 -82)",
    fill: "#6c63ff",
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M471.09,240.55c.1-1.11.16-2.23.16-3.36a37.33,37.33,0,0,0-1.45-10.3l-4.35.21-2-5.48,2.81-3.07a37.72,37.72,0,0,0-8.9-10.44l-3.43,2.66-4.78-3.34.55-4.13a37.17,37.17,0,0,0-13.27-3.45L435.14,204h-5.83l-1.92-3.7a37.33,37.33,0,0,0-18.13,8.63l2,3.84-4.12,4.12-4-1.25a37.29,37.29,0,0,0-5.73,12.46l3.88,2-1,5.74-4,1.25s0,.06,0,.09a37.25,37.25,0,0,0,2.49,13.4l4.32-.59,2.46,5.28-2.53,3.3a37.76,37.76,0,0,0,9.76,9.64l3.19-3,5.05,2.92-.18,4.18a37.28,37.28,0,0,0,12.9,2.29l.63,0,.92-4.25,5.81-.51,2.24,3.52a37.32,37.32,0,0,0,12.38-5.9l-1.68-4,4.47-3.75,3.84,1.59a37.45,37.45,0,0,0,6.79-11.92l-3.68-2.32,1.51-5.63Zm-37.3,24.68a28,28,0,1,1,28-28A28.07,28.07,0,0,1,433.79,265.23Z",
    transform: "translate(-159.54 -82)",
    fill: "#6c63ff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 161.25,
    y1: 22,
    x2: 155.25,
    y2: 22,
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 142.54,
    y1: 22,
    x2: 72.61,
    y2: 22,
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10,
    strokeDasharray: "12.71 12.71"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "66.25 22 60.25 22 60.25 28",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 60.25,
    y1: 39.33,
    x2: 60.25,
    y2: 124.33,
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10,
    strokeDasharray: "11.33 11.33"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 60.25,
    y1: 130,
    x2: 60.25,
    y2: 136,
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "207.75 222.5 343.75 222.5 343.75 103.5",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10,
    strokeDasharray: 12
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 261,
    width: 307,
    height: 80,
    fill: "url(#3e855d09-ea58-4275-8d16-3996ecf7bf97)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 266,
    width: 300,
    height: 71,
    fill: "#6c63ff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 283,
    width: 88,
    height: 4,
    fill: "#6c63ff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 292,
    width: 88,
    height: 4,
    opacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 307,
    width: 172,
    height: 4,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 301,
    r: 19,
    fill: "#6c63ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 301,
    r: 19,
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M763.66,564a1.34,1.34,0,0,0,.18-1.54c-4.3-8.61-8.61-6.45-21.33-31.06-13.54-26.17-10.17-34.94-15.24-39.94-2-2-4.06-8.68-6.78-9.85l-1.76-7.06a9.07,9.07,0,0,0,4.67-.72c2.8-1.24,4.93-3.6,6.82-6a45.56,45.56,0,0,0,7-11.84,32.36,32.36,0,0,0,2-9.73h0a33.28,33.28,0,0,0-.09-5,20.09,20.09,0,0,0,8.65-3.65,15,15,0,0,0,5.48-9.85h0c0-.39.09-.77.11-1.16a12.11,12.11,0,0,0,0-1.38,15,15,0,0,0-6.9-11.72,19.57,19.57,0,0,0-12-2.49A52.21,52.21,0,0,0,722.32,414c-1,.32-2.44.73-3.75,1.3a27.77,27.77,0,0,0-8.76-1.43c-4.86,0-9.62,1.28-14.31,2.54l-15.79,4.23c-3.5.94-7.15,2-9.76,4.47a8.26,8.26,0,0,0-.65.71l-.12.15a8.84,8.84,0,0,0-.57.81h0c-1.56,2.52-1.9,5.86,0,8.08A9.62,9.62,0,0,0,672,437.2a37.8,37.8,0,0,0,4.77,1.82,26,26,0,0,0-4.49,14.64c0,.3,0,.59,0,.89s0,.59,0,.89a26.09,26.09,0,0,0,26.09,26.09h.43l.76,6.12a54,54,0,0,0-8.91,12.46,13.89,13.89,0,0,0-4.37,10.76c-.05,4.34,1.13,9.65,2.28,17l-37.09-15.76-23.16,49.88,17.82,6.57c-8.37.38-13,6.5-12.93,12.73a12.32,12.32,0,0,0,3.66,9.21c6.45,6.45,14.28,73.63,14.28,73.63h3.26v7.05c-13.21.8-26.61,2.43-26.61,5.74a10.77,10.77,0,0,0,4.22,8.21c-.19-.23-.38-.48-.56-.74a14.26,14.26,0,0,0,3.38,2.57h71.75V672.14h.12v-1.79s-2.6,0-6.64.07v-6.34h3.26c2.91-26.22-9.78-60.24-12.53-67.2,4.47,0,9.17-.06,13.83-.32,19.79.89,53.82.67,60.67-10.75C772.9,573.19,766.81,566.44,763.66,564ZM664.23,595.6s1.49.15,4,.34c2.69,7.67,4.68,20.27,6.09,32.57A216.36,216.36,0,0,0,664.23,595.6Zm28.63-116.44a26.17,26.17,0,0,0,5.55.6h.2l.16,1.31A25.89,25.89,0,0,1,692.86,479.15ZM680.54,670.61H680v-.26s-2.33,0-6,.06v-6.33h6.52Z",
    transform: "translate(-159.54 -82)",
    fill: "url(#cf2af733-ecbd-4844-bce5-a175ed323afb)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "537.03 512 521 672 540.03 673 564 512 537.03 512",
    fill: "url(#41d3ff72-5c81-40b1-a081-9da170d960ca)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "538 512 526 670 538 670 555 512 538 512",
    fill: "#6c63ff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "865.16 506 880.92 667 862.16 667 847.08 506 865.16 506",
    fill: "url(#861d31c1-c685-4668-90c5-63e7f330b62f)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "865 507 877 665 865 665 848 507 865 507",
    fill: "#6c63ff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "583.9 505 569 666 588.9 666 605 505 583.9 505",
    fill: "url(#95aca10b-5f5c-4c4a-b42d-5e0345d77cda)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "585 505 573 663 585 663 602 505 585 505",
    fill: "#6c63ff"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "821.69 507 837 672 818.69 672 800 507 821.69 507",
    fill: "url(#447533d7-1588-4f38-833a-a610814ab16b)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "821 512 833 670 821 670 804 512 821 512",
    fill: "#6c63ff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 513,
    y: 503,
    width: 359,
    height: 17,
    fill: "url(#ff2ef3d2-e251-4fff-9ce5-91d443983582)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 503,
    width: 288,
    height: 15,
    fill: "#6c63ff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 804,
    y: 503,
    width: 66,
    height: 15,
    fill: "#6c63ff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 804.46,
    y: 503,
    width: 66,
    height: 15,
    opacity: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 629,
    y: 407,
    width: 135,
    height: 85,
    fill: "url(#3aee67b7-7918-445b-a8b6-3ab74317d2c0)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 410,
    width: 126,
    height: 79,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 676,
    y: 482,
    width: 41,
    height: 21,
    fill: "url(#6f730dc9-6dcb-4b79-bb23-db206ebc09d2)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 677.5,
    y: 482,
    width: 35,
    height: 21,
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 758,
    y: 410,
    width: 4,
    height: 79,
    fill: "#f5f5f5"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 482,
    width: 3,
    height: 21,
    fill: "#f5f5f5"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 438,
    width: 10,
    height: 10,
    fill: "url(#fad0dffe-d445-4baa-a242-e8cd9004e0b5)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 691,
    y: 439,
    width: 8,
    height: 8,
    fill: "#f5f5f5"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.84 430.1 565.23 457.89 543.22 499.7 478.58 475.88 499.84 430.1",
    fill: "#6c63ff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 502.52,
    y: 563.62,
    width: 17.96,
    height: 14.96,
    fill: "#f8c198"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 526.47,
    y: 563.62,
    width: 17.96,
    height: 14.96,
    fill: "#f8c198"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 542.87,
    cy: 376.5,
    r: 23.94,
    fill: "#f8c198"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "565.31 410.92 544.36 410.92 541.37 386.98 559.33 386.98 565.31 410.92",
    fill: "#f8c198"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M736.89,558.83s12,6,3,21-68.84,9-68.84,9,15,35.91,12,62.85H659.07S651.89,590,646,584c-7.63-7.63-1.86-22.22,13.11-19.23S736.89,558.83,736.89,558.83Z",
    transform: "translate(-159.54 -82)",
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M675.95,588.22s10.52,1,23.39,1.17c-9.34.1-18-.38-23.22-.75Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.71,564.85c23.37-.45,66.18-6.56,66.18-6.56a9,9,0,0,1,.9.55C725.6,560.5,688.6,565.27,670.71,564.85Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.75,564.05c-10.19,1.55-13.34,13-6.88,19.45,5.92,5.92,13.11,67.57,13.11,67.57h-4.9S651.89,589.42,646,583.5C638.56,576.1,643.78,562.15,657.75,564.05Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M686,657.59s-47.89,0-47.89,6,6,9,6,9H686Z",
    transform: "translate(-159.54 -82)",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M685.54,657.36V659c-8.34.06-46.25.65-46.25,6a9.13,9.13,0,0,0,2.24,5.9,9.89,9.89,0,0,1-3.88-7.53C637.65,657.36,685.54,657.36,685.54,657.36Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M760.83,558.83s12,6,3,21-68.84,9-68.84,9,15,35.91,12,62.85H683s-3-62.85-12-68.84-3-21,12-18S760.83,558.83,760.83,558.83Z",
    transform: "translate(-159.54 -82)",
    fill: "#263238"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M710,657.59s-47.89,0-47.89,6,6,9,6,9H710Z",
    transform: "translate(-159.54 -82)",
    fill: "#263238"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M720.64,484h7.28c2.87,0,4.92,7.2,7,9.22,4.66,4.59,1.56,12.63,14,36.65,11.68,22.58,15.63,20.61,19.58,28.5S698,565.9,698,565.9s3.79-15.12,3-26.21c-1.64-22.79-7.56-30.68.34-38.58C701.32,501.11,709.79,484,720.64,484Z",
    transform: "translate(-159.54 -82)",
    fill: "#ff5252"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "501.47 441.54 491.66 462.8 498.2 466.07 508.01 444.81 501.47 441.54",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M702.41,436.2a24.23,24.23,0,0,1,2.45.12,23.94,23.94,0,0,0,0,47.64,24.23,24.23,0,0,1-2.45.12,23.94,23.94,0,1,1,0-47.89Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M676.29,432.31c2.4-2.3,5.75-3.24,9-4.1l14.49-3.88c4.31-1.15,8.67-2.32,13.13-2.33a25.48,25.48,0,0,1,8,1.31c1.2-.52,2.55-.9,3.44-1.19a47.91,47.91,0,0,1,11.11-2.68,18,18,0,0,1,11,2.29,13.55,13.55,0,0,1,1.19,22.12,18.43,18.43,0,0,1-7.93,3.35A30.08,30.08,0,0,1,738,460.67a41.81,41.81,0,0,1-6.39,10.87c-1.73,2.21-3.69,4.37-6.26,5.51s-5.88,1-7.86-1c-1.46-1.47-2-3.63-2.33-5.67-1.51-8.08-3-17.37-10-21.68-4.39-2.7-9.28-2.44-14.18-2.41a29.55,29.55,0,0,1-12.71-2.91,8.83,8.83,0,0,1-3.18-2.14C672.89,438.72,673.89,434.61,676.29,432.31Z",
    transform: "translate(-159.54 -82)",
    fill: "#fccc63"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M746.49,425a18,18,0,0,0-11-2.29,47.91,47.91,0,0,0-11.11,2.68c-.89.3-2.24.67-3.44,1.19a25.48,25.48,0,0,0-8-1.31c-4.46,0-8.82,1.17-13.13,2.33l-14.49,3.88c-3.21.86-6.56,1.8-9,4.1a8.12,8.12,0,0,0-2.19,3.86,7.54,7.54,0,0,1,2.19-7.13c2.4-2.3,5.75-3.24,9-4.1l14.49-3.88c4.31-1.15,8.67-2.32,13.13-2.33a25.48,25.48,0,0,1,8,1.31c1.2-.52,2.55-.9,3.44-1.19a47.91,47.91,0,0,1,11.11-2.68,18,18,0,0,1,11,2.29,13.79,13.79,0,0,1,6.33,10.75,13,13,0,0,1-.11,2.33A13.79,13.79,0,0,0,746.49,425Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.88,450.44c0,.44,0,.87,0,1.31,0-.43,0-.85-.09-1.28Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M701,540c-1.64-22.79-7.56-30.68.34-38.58,0,0,8.46-17.11,19.32-17.11h7.28a3.33,3.33,0,0,1,2.4,1.63h-4.77c-10.86,0-19.32,17.11-19.32,17.11-7.9,7.9-2,15.79-.34,38.58.64,8.89-1.67,20.37-2.61,24.57-3.3,0-5.29,0-5.29,0S701.78,551.08,701,540Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff",
    opacity: 0.2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 703.52,
    y: 507.19,
    width: 26.16,
    height: 17.98,
    transform: "translate(1273.66 950.37) rotate(-180)",
    fill: "#ff5252"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M694.66,564.85c23.37-.45,66.18-6.56,66.18-6.56a9,9,0,0,1,.9.55C749.54,560.5,712.55,565.27,694.66,564.85Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.75,564.06c-10.26,1.56-13.42,13.09-5.8,18.17,9,6,12,68.84,12,68.84H683s-3-62.85-12-68.84C662.32,576.42,667.72,562.14,681.75,564.06Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.89,588.22s10.52,1,23.39,1.17c-9.34.1-18-.38-23.22-.75Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M727.91,519.92v28.63a18.28,18.28,0,0,1-19,18.28c-12.65-.49-27.24-.68-28.91,1-1.39,1.39-4.7,4.06-7.86,6.52a4.64,4.64,0,0,1-7.47-4.1c.4-4.81,1.91-9.93,6.34-11.4,3.57-1.19,10-1.91,16.38-2.34a21,21,0,0,0,19.53-21V519.92Z",
    transform: "translate(-159.54 -82)",
    fill: "#f8c198"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M664.7,570.23c.4-4.81,1.91-9.93,6.34-11.4,3.57-1.19,10-1.91,16.38-2.34a21,21,0,0,0,19.53-21V519.92h21v1.63H710.23v15.57a21,21,0,0,1-19.53,21c-6.42.43-12.82,1.15-16.38,2.34-4.43,1.48-5.95,6.6-6.34,11.4a4.62,4.62,0,0,0,1.11,3.44A4.67,4.67,0,0,1,664.7,570.23Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M710.06,657.36V659c-8.34.06-46.25.65-46.25,6a9.13,9.13,0,0,0,2.24,5.9,9.89,9.89,0,0,1-3.88-7.53C662.17,657.36,710.06,657.36,710.06,657.36Z",
    transform: "translate(-159.54 -82)",
    fill: "#fff",
    opacity: 0.2
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "233 518 233 736 618 736 618 452 629 452",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPage);
export default __webpack_public_path__ + "static/media/aiPage.bcd294697e30735794d60b17328a4b08.svg";
export { ForwardRef as ReactComponent };